export const GET_DEMOS = 'GET_DEMOS';
export const SET_DEMOS = 'SET_DEMOS';
